@for (page of pages; track page; let i = $index) {
<div [attr.data-index]="i">
  <onsip-url-picker
    [type]="type"
    [verbs]="verbs"
    [initialValue]="page"
    (delete)="onDeletePage(i)"
    (urlFormInit)="onUrlFormInit($event, i)"
  >
  </onsip-url-picker>
</div>
}
<button mat-button color="primary" (click)="onAddPage()">
  <mat-icon>add</mat-icon
  >{{
    type === "rule" ? ("ONSIP_I18N.ADD_RULE" | translate) : ("ONSIP_I18N.ADD_EXCEPTION" | translate)
  }}
</button>
